import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import { getParent, getSnapshot, applySnapshot, clone } from 'mobx-state-tree'
import { Operation } from '../../models/Operation';
import JobLabourForm from './LabourForm'

class LabourList extends Component {
  state = {
    isFormOpen: false,
    selectedOperation: null,
    clone: null
  }
  render() { 
    const qty = this.props.qty ? this.props.qty : 1
    return (
      <div>
        <Table striped compact='very'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Setup</Table.HeaderCell>
              <Table.HeaderCell>Operations</Table.HeaderCell>
              <Table.HeaderCell>Extra</Table.HeaderCell>
              {!this.props.noEdit && <Table.HeaderCell />}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.props.labour.map((operation, index) => {
              return (<Table.Row key={index}>
                <Table.Cell>{operation.description} {operation.comment ? <small>{operation.comment}</small> : ''}</Table.Cell>
                <Table.Cell>{operation.numberOfSetups} @ {operation.minutesPerSetup} min</Table.Cell>
                <Table.Cell>{operation.numberOfOperations * qty} @ {operation.secondsPerOperation} sec</Table.Cell>
                <Table.Cell>{operation.extraMinutesPerUnit ? operation.extraMinutesPerUnit * qty + ' min' : ''}</Table.Cell>
                {!this.props.noEdit &&
                  <Table.Cell>
                    <a href='#edit-operation' onClick={() => this.editOperation(operation)}>Edit</a>
                    &emsp;
                    <a href='#remove-operation' onClick={() => this.removeOperation(operation)}>Remove</a>
                  </Table.Cell>
                }
              </Table.Row>)
            })}
            {!this.props.noEdit &&
            <Table.Row>
              <Table.Cell colSpan='5'>
                <a href='#add-labour' onClick={this.addOperation}>Add operation</a>
              </Table.Cell>
            </Table.Row>
            }
          </Table.Body>
        </Table>
        {this.state.isFormOpen &&
          <JobLabourForm model={this.state.clone} onSave={this.commitChanges} onCancel={this.closeForm} />
        }
      </div>
    )
  }

  addOperation = () => {
    this.setState({
      selectedOperation: null,
      clone: Operation.create(),
      isFormOpen: true
    })
  }

  editOperation = operation => {
    this.setState({
      selectedOperation: operation,
      clone: clone(operation),
      isFormOpen: true
    })
  }

  removeOperation = operation => {
    operation.remove()
  }


  closeForm = () => {
    this.setState({
      selectedOperation: null,
      clone: null,
      isFormOpen: false
    })
  }

  commitChanges = () => {
    const { clone } = this.state;
    if (this.state.selectedOperation) {
      applySnapshot(this.state.selectedOperation, getSnapshot(clone))
    } else {
      getParent(this.props.labour).addLabour(clone)
    }
    this.closeForm()
  }
}
 
export default observer(LabourList);


// WEBPACK FOOTER //
// ./src/components/jobs/LabourTable.js